import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./plugins/element.js";
import vuescroll from "vuescroll";
import "vuescroll/dist/vuescroll.css";
import "./assets/css/base.css";
import "./styles/index.less";
import scrollTop from "./components/ScrollTop/index";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(vuescroll);
Vue.use(scrollTop);

router.beforeEach((to, from, next) => {
	console.log(to);
	console.log(from);
	next();
});

router.afterEach(() => {
	window.scrollTo(0, 0);
});

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
